<!-- 报警开关日志 -->

<template>
  <div class='sysLogPage'>
    <div class='icon-desc'>
      <AlarmSwitch
        v-if='detailObj'
        :related='detailObj.alarm_bind'
        :alarmSwitch='detailObj.alarm_switch'
        :carrier-ids='[detailObj.id]'
        :carrier-type='detailObj.typeId'
        :scene-id='detailObj.scene_id'
        class='mr-5'
        :getList="
                    () => {
                        $emit('getList');
                        getListFn();
                    }
                "
      ></AlarmSwitch>
      <IconDesc :icon-desc='alarmLogIconDesc'></IconDesc>
    </div>
    <v-search
      :formContent='formContent'
      :SearchForm='SearchForm'
      :inline='true'
      :optareBtn='optareBtn'
      class='search'
      @DelFn='DelFn'
      @resetFn='resetFn'
      @searchFn='getListFn'
      @confirmFn='getListFn'
    >
    </v-search>
    <div class='componentPage'>
      <tablePage :tableData='tableData' :loading='loading' @choozeTableFn='choozeTableFn' @detailRow='detailRow'
                 @delRow='delRow' />
      <Pagination class='pagination' :total='total' :page.sync='SearchForm.iDisplayStart'
                  :limit.sync='SearchForm.iDisplayLength' @pagination='getListFn'></Pagination>
    </div>
    <AlarmLogDetail :show.sync='isShow' :id='logId' :title='title' @getList='getListFn'></AlarmLogDetail>
    <AlarmSwitchDialog></AlarmSwitchDialog>
  </div>
</template>

<script>
import getRange from '@/utils/getRange.js'
import { delAlarmSwitchLog, getLogPage } from '@/api/modules/alarmLog'
import mixinForm from '@/utils/formMixins.js'
import tablePage from './components/AlarmLog/AlarmLogTable.vue'
import AlarmLogDetail from './components/AlarmLog/AlarmLogDetail.vue'
import IconDesc from '@/components/IconDesc/IconDesc'
import alarmLogIconDesc from '@/pages/journal/config/alarmLogIconDesc'
import { filterateSelection } from '@/utils/searchSelectFormat'
import AlarmSwitch from '@/components/AlarmSwitch/AlarmSwitch.vue'
import AlarmSwitchDialog from '@/components/AlarmSwitch/AlarmSwitchDialog.vue'
import { sCarrier, sCustomer, sEvent, sOperationTime, sOperator, sTriggerName } from './config/search'

export default {
  mixins: [mixinForm, getRange],
  // 可能会传入客户Id 即为指定客户
  props: ['detailObj'],
  components: {
    tablePage,
    AlarmLogDetail,
    IconDesc,
    AlarmSwitch,
    AlarmSwitchDialog
  },
  computed: {
    i18n () {
      return this.$i18n.locale
    },
    isSysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      return (currentUser.sysScope && currentUser.sysAdmin) || (currentUser.sysScope && !currentUser.sysAdmin)
    },
    alarmLogIconDesc: () => alarmLogIconDesc
  },
  data () {
    return {
      isSet: false,
      choozeTable: [],
      formContent: [sTriggerName, sEvent, sCarrier, sOperator, sOperationTime, sCustomer],
      SearchForm: {
        triggerName: null,
        event: null,
        from: null,
        to: null,
        time: [],
        carrierName: null,
        operator: null,
        sceneId: null
        // type: '0'
      },
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['delRange'],
          text: 'public.btn_delete',
          method: 'DelFn'
        }
      ],
      treeData: [],
      isLogLoading: false,
      logId: 0,
      rangeArray: []
    }
  },
  created () {
    if (!this.isSysAdmin) {
      this.formContent.pop()
    }
    this.getRangeFn()
  },
  methods: {
    getRangeFn () {
      this.getRange().then(({ result }) => {
        this.rangeArray = this.formContent[this.formContent.length - 1].selectParam = result.filter(item => {
          (item.value = item.id), (item.label = item.name)
          return item.id > 0
        })
      })
    },
    getListFn () {
      this.loading = true
      if (this.detailObj) {
        this.SearchForm.carrierName = this.detailObj.keycode || this.$route.query.keycode
      }
      if (this.SearchForm.time && this.SearchForm.time.length > 0) {
        this.SearchForm.from = this.$dateParseTime(this.SearchForm.time[0])
        this.SearchForm.to = this.$dateParseTime(this.SearchForm.time[1])
      }
      const query = { ...this.SearchForm }
      delete query.time
      getLogPage(query)
        .then(({
          result,
          pageInfo
        }) => {
          this.tableData = result
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    delRow (row) {
      this.TODOTIPDEL([row.id])
    },
    detailRow (row) {
      this.isShow = true
      this.title = `[${row.alarmTriggerName}]` + $t('integration.detailed_information')
      this.logId = row.id
    },
    resetFn () {
      this.SearchForm = {
        scopeId: null,
        module: null,
        from: null,
        to: null,
        time: [],
        action: null,
        operator: null,
        iDisplayStart: 0,
        iDisplayLength: 15
        // type: '0'
      }
      this.getListFn()
    },
    /** 表格勾选 */
    choozeTableFn (array) {
      this.choozeTable = array
    },
    DelFn () {
      if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      const ids = this.choozeTable.map(item => item.id)
      this.TODOTIPDEL(ids)
    },
    /**
     *
     * @param {*param 选中数据id} param string
     */
    TODOTIPDEL (param) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_confirm'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          delAlarmSwitchLog(param).then(({ result }) => {
            this.getListFn()
            this.$message.success(this.$t('public.tip_del_succ').toString())
          })
        })
        .catch(() => {
        })
    }
  },
  mounted () {
    if (this.detailObj) {
      // 这里还差监测点条件需要过滤
      this.formContent = filterateSelection(this.formContent, ['sceneId', 'carrierName'])
    } else {
      // 判断权限过滤掉客户
      this.formContent = filterateSelection(this.formContent)
    }
  }
}
</script>

<style lang='scss' scoped>
.sysLogPage {
  position: relative;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .icon-desc {
    position: absolute;
    right: 20px;
    top: 15px;
    z-index: 200;
  }

  .search {
    position: relative;

    .logPonit {
      position: absolute;
      right: 0;
      top: 10px;

      span {
        color: #fff;
        font-size: 14px;
        font-weight: bold;
      }

      i {
        color: #fff;
        float: right;
        line-height: 30px;
      }
    }
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
